import { type FC } from "react";
import { Chip, type ChipProps } from "@mui/material";
import type { CustomerStatus } from "../../customersApi";

interface Props {
  status: CustomerStatus;
}

const statusColor: Record<CustomerStatus, ChipProps["color"]> = {
  "to check": "default",
  "no interest": "default",
  cold: "default",
  warm: "warning",
  lead: "warning",
  "active lead": "info",
  active: "success",
  adult: "success",
};

const inactiveStatuses: CustomerStatus[] = ["to check", "no interest", "cold"];

const ClientStatusChip: FC<Props> = ({ status }) => (
  <Chip
    size="small"
    label={status}
    color={statusColor[status]}
    variant={inactiveStatuses.includes(status) ? "outlined" : "filled"}
  />
);

export default ClientStatusChip;
